
export const ProjectStatusByInt: { [ key: number ]: string } = {
    1: "INACTIVE",
    2: "ACTIVE",
    3: "PAUSED",
    4: "DONE",
    5: "LOCKED"
}

export const ProjectStatusByName = {
    INACTIVE: 1,
    ACTIVE: 2,
    PAUSED: 3,
    DONE: 4,
    LOCKED: 5
}

export interface ProjectStatusProp {
    status: number
}